var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
import cookie from "cookie";
let nativeInvokeIndex = 0;
const isIOS = /iPhone|iPad/i.test(window.navigator.userAgent);
const isChelunHost = /chelun\.com|eclick\.cn/.test(window.location.host);
export const info = {
    chelun: false,
    chaweizhang: false,
    chelunshequ: false,
    jiakaotong: false,
    chaojijiaolian: false
};
if (isChelunHost) {
    const cookies = cookie.parse(document.cookie);
    const isLogin = (_a = cookies["chelun_isLogin"], (_a !== null && _a !== void 0 ? _a : window["__chelun_isLogin"]));
    // 是否需要离线，这是个IOS专有值，转换为布尔值
    info.offline = window["__chelun_wcache"] === 1 ? true : false;
    // 登录与否判断，转换为布尔值
    info.isLogin =
        !isLogin || isLogin === "false" || isLogin === "0" ? false : true;
    info.appName = (_b = cookies["chelun_appName"], (_b !== null && _b !== void 0 ? _b : window["__chelun_appName"]));
    info.appVersion = (_c = cookies["chelun_appVersion"], (_c !== null && _c !== void 0 ? _c : window["__chelun_appVersion"]));
    info.appChannel = (_d = cookies["chelun_appChannel"], (_d !== null && _d !== void 0 ? _d : window["__chelun_appChannel"]));
    info.acToken = (_e = cookies["chelun_acToken"], (_e !== null && _e !== void 0 ? _e : window["__chelun_acToken"]));
    info.auth = (_f = cookies["chelun_auth"], (_f !== null && _f !== void 0 ? _f : window["__chelun_auth"]));
    info.cuuid = (_g = cookies["chelun_cuuid"], (_g !== null && _g !== void 0 ? _g : window["__chelun_cuuid"]));
    info.device = (_h = cookies["chelun_device"], (_h !== null && _h !== void 0 ? _h : window["__chelun_device"]));
    info.osType = (_j = cookies["chelun_osType"], (_j !== null && _j !== void 0 ? _j : window["__chelun_osType"]));
    info.osVersion = (_k = cookies["chelun_osVersion"], (_k !== null && _k !== void 0 ? _k : window["__chelun_osVersion"]));
    info.uuid = (_l = cookies["chelun_uuid"], (_l !== null && _l !== void 0 ? _l : window["__chelun_uuid"]));
    // APP判断
    if (info.appName) {
        const appName = info.appName.toLocaleLowerCase();
        info.chelun = true;
        if (appName === "queryviolations") {
            info.chaweizhang = true;
        }
        else if (appName === "chelun") {
            info.chelunshequ = true;
        }
        else if (appName === "drivingtest") {
            info.jiakaotong = true;
        }
        else if (appName === "supercoach") {
            info.chaojijiaolian = true;
        }
    }
}
/**
 * JSBridge调用原生功能
 * @param path 完整路径
 * @param param 参数
 * @param schema 当前请求的schema
 */
export function invoke(path, param, schema = "chelunJSBridge") {
    // 非车轮APP之内，不发起任何请求
    if (!isChelunHost) {
        return;
    }
    // schema的完整URL
    let url = `${schema}://${path.replace(/^\/*|\/*$/g, "")}`;
    // 模拟发送请求
    const nativeCall = (url) => {
        let temp = document.createElement("iframe");
        document.body.appendChild(temp);
        temp.style.display = "none";
        // 安全的删除临时对象
        let hasRemoved = false;
        const removeIframe = () => {
            if (!hasRemoved) {
                hasRemoved = true;
                temp.remove();
            }
        };
        /**
         * 如果时ios离线H5，需要做包装
         */
        if (isIOS && info.offline) {
            url = `https://${window.location.host}?cl_offline_schema=${encodeURIComponent(url)}`;
        }
        temp.src = url;
        temp.onload = removeIframe;
        /**
         * 清理无效的iframe
         */
        window.setTimeout(removeIframe, 300);
    };
    // 如果没有参数选项，直接发送请求
    if (!param || typeof param !== "object") {
        nativeCall(url);
        return;
    }
    let hashIndex;
    let pairs = [];
    for (let key in param) {
        if (!param.hasOwnProperty(key)) {
            continue;
        }
        if (typeof param[key] === "function") {
            nativeInvokeIndex += 1;
            window[`__MCL_CALLBACK_${nativeInvokeIndex}`] = param[key];
            if (key === "callback") {
                hashIndex = nativeInvokeIndex;
            }
            else {
                pairs.push(`${encodeURIComponent(key)}=${nativeInvokeIndex}`);
            }
        }
        else {
            pairs.push(`${encodeURIComponent(key)}=${encodeURIComponent(param[key])}`);
        }
    }
    // 判断是否有参数
    if (pairs.length > 0) {
        url += `?${pairs.join("&")}`;
    }
    // 判断是否有hash统一回调
    if (typeof hashIndex === "number") {
        url += `#${hashIndex}`;
    }
    // 发起调用
    nativeCall(url);
}
